const env = window._env_ || {};
const version = env.REACT_APP_VERSION ? parseInt(env.REACT_APP_VERSION.split('.')[1]) : 1;
export const DB_VERSION = env.REACT_APP_X_QUOTE_MODE === 'production'
    ? version + 1
    : version;
